import { render, staticRenderFns } from "./ScreeningHeader.vue?vue&type=template&id=472254f5&scoped=true&"
import script from "./ScreeningHeader.vue?vue&type=script&lang=js&"
export * from "./ScreeningHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningHeader.vue?vue&type=style&index=0&id=472254f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472254f5",
  null
  
)

export default component.exports